import { useCurrentUser } from '@qualio/ui-components';

// copilot_enabled isn't declared on CL's CurrentUserCompany type yet, mirrors qualio-frontend's useCopilotAccess
type CompanyWithCopilotEnabled = { copilot_enabled?: boolean };

export const useCopilotAccess = (): boolean => {
  const currentUser = useCurrentUser();

  const hasCapability = Boolean(currentUser?.capabilities?.copilot);
  const isEnabled = Boolean(
    (currentUser?.company as CompanyWithCopilotEnabled | undefined)
      ?.copilot_enabled,
  );
  return hasCapability && isEnabled;
};
